import tokenColors from "@/token-colors.json"

function tokenColorGuard(aid: string): aid is keyof typeof tokenColors.colors {
  return aid in tokenColors.colors
}

export function getHighlightColors(aid: number | bigint): string[] {
  const strAid = String(aid)
  if (tokenColorGuard(strAid)) {
    return tokenColors.colors[strAid].split(" ")
  }
  return ["primary"];
}

export function getHighlightClasses(aid: number | bigint, classPrefix: string, classSuffix: string = ''): string {
  const colors = getHighlightColors(aid);
  if (classPrefix.endsWith("text"))
    return colors.map(color => color.startsWith("dark:") ? `dark:${classPrefix}-${color.slice(5)}${classSuffix}` : `${classPrefix}-${color}${classSuffix}`).join(" ")
  else {
    return colors.slice(0, 1).map(color => color.startsWith("dark:") ? `${classPrefix}-${color.slice(5)}${classSuffix}` : `${classPrefix}-${color}${classSuffix}`).join(" ")
  }
}